var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#C61D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H7.33333H18",
    stroke: "#C61D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 7.99992V17.3333C16.6668 17.6869 16.5264 18.026 16.2763 18.2761C16.0263 18.5261 15.6871 18.6666 15.3335 18.6666H8.66683C8.31321 18.6666 7.97407 18.5261 7.72402 18.2761C7.47397 18.026 7.3335 17.6869 7.3335 17.3333V7.99992M9.3335 7.99992V6.66659C9.3335 6.31296 9.47397 5.97382 9.72402 5.72378C9.97407 5.47373 10.3132 5.33325 10.6668 5.33325H13.3335C13.6871 5.33325 14.0263 5.47373 14.2763 5.72378C14.5264 5.97382 14.6668 6.31296 14.6668 6.66659V7.99992",
    stroke: "#C61D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 11.3333V15.3333",
    stroke: "#C61D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 11.3333V15.3333",
    stroke: "#C61D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.57682f32d4c1cc6e53acbcac4363ee89.svg";
export { ForwardRef as ReactComponent };